var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card typo-sans"},[_c('div',{staticClass:"card__headline"},[_vm._v("\n    "+_vm._s(_vm.headline)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"card__paragraph",domProps:{"innerHTML":_vm._s(_vm.paragraph_html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }